import { useAuthStore } from "@/lib/store"
import { useCallback } from "react"
import { useDisconnect } from "wagmi";
import { useSentry } from "./use-sentry";

export const useGianoDisconnect = () => {
    const { disconnectAsync: disconnect } = useDisconnect()
    const { logout } = useAuthStore();
    const { setUser } = useSentry()

    const handleDisconnect = useCallback(async () => {
        await disconnect()
        logout()
        setUser({ })
    }, [disconnect, logout, setUser])

    return {
        disconnect: handleDisconnect,
    }
}